import React, {useEffect, useRef, useState} from 'react';
import {useFormContext, useFieldArray} from 'react-hook-form';
import {useCompanyPageStyles} from '../companyPageStyles';
import {globalUseClasses} from '../../../styles/globalClasses';
import * as allConstants from '../../../constants/allConstants';
import Grid from '@mui/material/Grid';
import {Box, Button, Card, CardContent, List, Typography, ListItem} from '@mui/material';
import CustomFormBlock from '../../../pieces/inputs/formBlock';
import {inputTypes} from '../../../pieces/inputs/formInput';
import Utils from '../../../utils/utils';
import {AddRowButton, DeleteEquipmentRowButton,variants} from '../../../pieces/addDeleteEquipmentRowButtons';
import base_url from '../../../baseUrls';
import {companyPropTypes, companyDefaultProps} from './panelProps';
import {NotAllowedToEditSection} from './notAllowedToEditSection';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import {generatePriceListPdf, normalizePriceListServices} from '../../../utils/priceListPdf';
import {PriceListFlyerTemplate} from './priceListFlyerTemplate';

export const CompanyFinancial = (props)=> {
  const classes = {...useCompanyPageStyles(), ...globalUseClasses()};
  const COMPANY_FIELDS = allConstants.COMPANY_FIELDS;
  const PRODUCT_FIELDS = allConstants.PRODUCT_FIELDS;
  const formMethods = useFormContext();
  const [currentTab, setCurrentTab] = useState(0);
  const priceFlyerRef = useRef(null);

  const isIpermitInvite = props.tabProps.isIpermitInvite;

  const getCompanyData = ()=> {
    const initialData = props.tabProps?.companyData || {};
    return {...initialData, ...formMethods.getValues()};
  };

  const companyData = getCompanyData();

  // console.log('company data');
  // console.log(companyData);
  
  const watchPaymentMethod = formMethods.watch(COMPANY_FIELDS.PAYMENT_METHOD.api_name);

  useEffect(()=> {
    if(watchPaymentMethod === allConstants.PAYMENT_METHODS.CREDIT_CARD.value) {
      const currValues = formMethods.getValues();
      const currPaymentFee = currValues[COMPANY_FIELDS.PAYMENT_FEE.api_name];
      formMethods.setValue(allConstants.COMPANY_FIELDS.PAYMENT_FEE.api_name, currPaymentFee || 3);
    }
  }, [watchPaymentMethod]);

  const getFileDefault = (field, parent)=> {
    const savedFile = sessionStorage.getItem(`${parent}.${field}`);
    const savedName = sessionStorage.getItem(`${parent}.${field}_name`);
    if(savedFile) {
      return {id: 'file ready to upload', name: savedName};
    } else {
      const formData =  getDefaultValue(parent);
      return {
        id: formData?.[field] || formData?.fileId,
        name: formData?.fileName
      };
    }
  };

  const getDefaultValue = (field, parent = null) => {
    if (parent) {
      return companyData?.[parent]?.[field];
    }
    return companyData?.[field];
  };

  const commonFieldProps = {
    fullWidth: true,
    maxWidth: '100%',
  };

  const productsCollectionName = COMPANY_FIELDS.PRICE_LIST.api_name;

  const productRow = {
    [PRODUCT_FIELDS.NAME.api_name]: '',
    [PRODUCT_FIELDS.PRICE.api_name]:'',
    [PRODUCT_FIELDS.CODE.api_name]:'',
    [PRODUCT_FIELDS.ID.api_name]: null,
    [PRODUCT_FIELDS.LAST_PRICE]: '',
    [PRODUCT_FIELDS.LAST_UPDATE]: null,
    [PRODUCT_FIELDS.LAST_UPDATE_STR]: '',
    [PRODUCT_FIELDS.UPDATED_BY]: '',
  };

  const {fields, append} = useFieldArray({
    control: formMethods.control,
    name: productsCollectionName,
  });
  formMethods.watch(productsCollectionName);

  const getServicesForDownload = ()=> {
    const rows = getCompanyData()?.[productsCollectionName] || [];
    return normalizePriceListServices(rows);
  };
  const [pdfFlyerServices, setPdfFlyerServices] = useState(getServicesForDownload());
  const [pdfFlyerPageIndex, setPdfFlyerPageIndex] = useState(0);
  const [pdfFlyerTotalPages, setPdfFlyerTotalPages] = useState(1);

  const waitForFlyerRender = () => new Promise((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(resolve));
  });

  const handleDownloadPriceList = async ()=> {
    const currentData = getCompanyData();
    const services = normalizePriceListServices(currentData?.[productsCollectionName] || []);
    const companyName = currentData?.[COMPANY_FIELDS.NAME.api_name];

    if(services.length === 0) {
      window.alert('Please add at least one service before downloading the price list.');
      return;
    }

    const downloaded = await generatePriceListPdf({
      companyName,
      services,
      flyerElement: priceFlyerRef.current,
      onBeforePageCapture: async (pageServices, pageIndex, totalPages)=> {
        setPdfFlyerServices(pageServices);
        setPdfFlyerPageIndex(pageIndex);
        setPdfFlyerTotalPages(totalPages);
        await waitForFlyerRender();
      },
    });

    if(!downloaded) {
      window.alert('Unable to prepare the price list PDF. Please try again.');
    }
    setPdfFlyerServices(services);
    setPdfFlyerPageIndex(0);
    setPdfFlyerTotalPages(1);
  };

  const productSubformDefaultProps = (index) => ({
    defaultValue: '',
    isEditable: true,
    nested: true,
    fullWidth: true,
    parent: `${productsCollectionName}[${index}]`
  });


  const deletePriceListRow = (index) => {
    try {
      const priceList = [...formMethods.getValues()?.[allConstants.COMPANY_FIELDS.PRICE_LIST.api_name]];
      priceList.splice(index, 1);
      formMethods.setValue(allConstants.COMPANY_FIELDS.PRICE_LIST.api_name, priceList);
    } catch(e){

    }
  };

  const getFinancialInfo = () => {
    return (
      <Grid container width={'100%'}>
        <Grid item sm={12} md={6} flex={1}>
          <Card className={classes.card_block}>
            <CardContent className={classes.half_width}>
              <Box className={classes.two_col_container}
                sx={{
                  gridTemplateColumns: '3fr 1fr !important'
                }}
              >
                <CustomFormBlock
                  {...props.inputDefaultProps}
                  {...commonFieldProps}
                  field={{...COMPANY_FIELDS.PAYMENT_METHOD, ...{required: !isIpermitInvite}}}
                  options={Utils.getOptions(allConstants.PAYMENT_METHODS)}
                  inputType={inputTypes.singleSelect}
                  defaultValue={getDefaultValue(COMPANY_FIELDS.PAYMENT_METHOD.api_name)}
                  // isEditable={true}

                />
                <CustomFormBlock
                  {...props.inputDefaultProps}
                  {...commonFieldProps}
                  field={COMPANY_FIELDS.PAYMENT_FEE}
                  inputType={inputTypes.number}
                  defaultValue={getDefaultValue(COMPANY_FIELDS.PAYMENT_FEE.api_name)}
                  // isEditable={true}

                />
              </Box>
              <CustomFormBlock
                {...props.inputDefaultProps}
                {...commonFieldProps}
                field={COMPANY_FIELDS.CLASSIFICATION}
                defaultValue={getDefaultValue(COMPANY_FIELDS.CLASSIFICATION.api_name)}
                // isEditable={true}

              />
              <CustomFormBlock
                {...props.inputDefaultProps}
                {...commonFieldProps}
                inputType={inputTypes.file}
                field={COMPANY_FIELDS.PAYMENT_AUTH_FORM_FILE}
                nested={true}
                parent={COMPANY_FIELDS.PAYMENT_AUTH_FORM.api_name}
                defaultValue={getFileDefault(COMPANY_FIELDS.PAYMENT_AUTH_FORM_FILE.api_name, COMPANY_FIELDS.PAYMENT_AUTH_FORM.api_name)}
                // isEditable={true}
              />
              <CustomFormBlock
                {...props.inputDefaultProps}
                {...commonFieldProps}
                field={COMPANY_FIELDS.ACCEPT_REGISTRATION_BY}
                defaultValue={getDefaultValue(COMPANY_FIELDS.ACCEPT_REGISTRATION_BY.api_name)}
                isEditable={false}
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid item sm={12} md={6} flex={1}>
          <Card className={classes.card_block} sx={{height: '100%'}}>
            <CardContent className={classes.half_width}>
              <Box className={classes.two_col_container}
                sx={{
                  gridTemplateColumns: '3fr 1fr !important'
                }}
              >
                <CustomFormBlock
                  {...props.inputDefaultProps}
                  {...commonFieldProps}
                  field={COMPANY_FIELDS.QB_EMAIL}
                  defaultValue={getDefaultValue(COMPANY_FIELDS.QB_EMAIL.api_name)}
                  // isEditable={true}

                />
                <CustomFormBlock
                  {...props.inputDefaultProps}
                  {...commonFieldProps}
                  field={COMPANY_FIELDS.QB_ID}
                  inputType={inputTypes.number}
                  defaultValue={getDefaultValue(COMPANY_FIELDS.QB_ID.api_name)}
                  // isEditable={true}

                />
              </Box>
              <CustomFormBlock
                {...props.inputDefaultProps}
                {...commonFieldProps}
                field={COMPANY_FIELDS.CREDIT_LIMIT}
                defaultValue={getDefaultValue(COMPANY_FIELDS.CREDIT_LIMIT.api_name)}
                // isEditable={true}

              />
              <CustomFormBlock
                {...props.inputDefaultProps}
                {...commonFieldProps}
                field={COMPANY_FIELDS.ACCOUNTING_CONTACT}
                defaultValue={getDefaultValue(COMPANY_FIELDS.ACCOUNTING_CONTACT.api_name)}
                // isEditable={true}

              />
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'nowrap',
                  alignItems: 'center',
                  gap: 3,
                  width: '100%',
                }}
              >
                {/* <CustomFormBlock
                  {...props.inputDefaultProps}
                  renderLabel={false}
                  labelLeft={true}
                  field={COMPANY_FIELDS.CITY_INSPECTION}
                  inputType={inputTypes.checkbox}
                  disabled={!props.inputDefaultProps.isEditable}
                  defaultValue={getDefaultValue(COMPANY_FIELDS.CITY_INSPECTION.api_name)}
                /> */}
                <Box sx={{flex: '1 1 0', minWidth: 0}}>
                  <CustomFormBlock
                    {...props.inputDefaultProps}
                    fullWidth
                    maxWidth="100%"
                    renderLabel={false}
                    labelLeft={true}
                    field={COMPANY_FIELDS.CHARGE_INITIAL_HERS}
                    inputType={inputTypes.checkbox}
                    disabled={!props.inputDefaultProps.isEditable}
                    defaultValue={getDefaultValue(COMPANY_FIELDS.CHARGE_INITIAL_HERS.api_name)}
                  />
                </Box>
                <Box sx={{flex: '1 1 0', minWidth: 0}}>
                  <CustomFormBlock
                    {...props.inputDefaultProps}
                    fullWidth
                    maxWidth="100%"
                    renderLabel={false}
                    labelLeft={true}
                    field={COMPANY_FIELDS.ALL_IN_ONE}
                    inputType={inputTypes.checkbox}
                    disabled={!props.inputDefaultProps.isEditable}
                    defaultValue={getDefaultValue(COMPANY_FIELDS.ALL_IN_ONE.api_name)}
                  />
                </Box>
              </Box>

            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  };

  const getPriceList = () => {
    const servicesForDownload = getServicesForDownload();

    return (
      <Grid container width={'100%'}>
        <Grid item sm={12} flex={1}>
          <Card className={classes.card_block}>
            <CardContent>
              <Box mb={2} display={'flex'} justifyContent={'flex-end'}>
                {servicesForDownload.length > 0 && (
                  <Button
                    variant="contained"
                    onClick={handleDownloadPriceList}
                  >
                    Download Price List (PDF)
                  </Button>
                )}
              </Box>
              {/* <Box mb={2}>
                <Typography className={classes.eq_name}>Price list</Typography>
              </Box> */}
              <List>
                <ListItem sx={{
                  display: 'grid',
                  gridTemplateColumns: '2fr 0.5fr 0.5fr 1fr 1fr 0.5fr 0.5fr',
                  gap: '8px',
                  alignItems: 'flex-start',
                  textTransform: 'uppercase'
                }}>
                  <Typography>ipermit services</Typography>
                  <Typography>price ($)</Typography>
                  <Typography>last price ($)</Typography>
                  <Typography>last update</Typography>
                  <Typography>updated by</Typography>
                  <Typography>product code</Typography>
                  <Typography>del</Typography>
                </ListItem>

              </List>
              <form>
                <List>
                  {fields.map((item, index) => (
                    <ListItem key={item.id} sx={{
                      display: 'grid',
                      paddingTop: '0',
                      paddingBottom: '0',
                      gridTemplateColumns: '2fr 0.5fr 0.5fr 1fr 1fr 0.5fr 0.5fr',
                      gap: '8px',
                      alignItems: 'flex-start'
                    }}>

                      <CustomFormBlock
                        {...props.inputDefaultProps}
                        {...commonFieldProps}
                        {...productSubformDefaultProps(index)}
                        field={PRODUCT_FIELDS.NAME}
                        inputType={inputTypes.autoComplete}
                        autocompleteParams={{
                          url: `${base_url.api}products/autocomplete`,
                          getRequestParams: (value)=> {
                            if(value) {
                              return {
                                name: value
                              };
                            }
                          },
                          collectionName: productsCollectionName,
                          fill: [PRODUCT_FIELDS.PRICE, PRODUCT_FIELDS.CODE, PRODUCT_FIELDS.ID, PRODUCT_FIELDS.LAST_UPDATE, PRODUCT_FIELDS.UPDATED_BY],
                          filter: (options)=> {
                            const existingRows = formMethods.getValues()?.[allConstants.COMPANY_FIELDS.PRICE_LIST.api_name];
                            if(!existingRows) return options;
                            const existingProducts = existingRows.map((row)=> row[PRODUCT_FIELDS.NAME.api_name]);
                            return options.filter((option)=> !existingProducts.includes(option[PRODUCT_FIELDS.NAME.api_name]));
                          }
                        }
                        }

                      />
                      <CustomFormBlock
                        {...props.inputDefaultProps}
                        {...commonFieldProps}
                        {...productSubformDefaultProps(index)}
                        field={PRODUCT_FIELDS.ID}
                        hide={true}
                      />

                      <CustomFormBlock
                        {...props.inputDefaultProps}
                        {...commonFieldProps}
                        {...productSubformDefaultProps(index)}
                        ignoreValidation={true}
                        preventCapitalize={true}
                        field={PRODUCT_FIELDS.PRICE}

                      />
                      <CustomFormBlock
                        {...props.inputDefaultProps}
                        {...commonFieldProps}
                        {...productSubformDefaultProps(index)}
                        field={PRODUCT_FIELDS.LAST_PRICE}
                      
                        isEditable={false} 
                      />
                      <CustomFormBlock
                        {...props.inputDefaultProps}
                        {...commonFieldProps}
                        {...productSubformDefaultProps(index)}
                        field={PRODUCT_FIELDS.LAST_UPDATE_STR}
                        isEditable={false}
                        //inputType={inputTypes.date}
                      />
                      <CustomFormBlock
                        {...props.inputDefaultProps}
                        {...commonFieldProps}
                        {...productSubformDefaultProps(index)}
                        field={PRODUCT_FIELDS.LAST_UPDATE}
                        hide={true}
                        isEditable={false}
                        //inputType={inputTypes.date}
                      />
                      <CustomFormBlock
                        {...props.inputDefaultProps}
                        {...commonFieldProps}
                        {...productSubformDefaultProps(index)}
                        field={PRODUCT_FIELDS.UPDATED_BY}
                        isEditable={false} 
                      />
                      <CustomFormBlock
                        {...props.inputDefaultProps}
                        {...commonFieldProps}
                        {...productSubformDefaultProps(index)}
                        field={PRODUCT_FIELDS.CODE}
                        isEditable={false}

                      />
                      {!props.inputDefaultProps.viewMode && <DeleteEquipmentRowButton eqName={'products'}
                        extraStyles={{alignSelf: 'baseline',
                          top: '8px',
                          position: 'relative',
                          padding: '0'
                        }}
                        deleteAction={() => deletePriceListRow(index)}
                      />}
                    </ListItem>
                  ))}
                </List>
                {!props.inputDefaultProps.viewMode && props.inputDefaultProps.isEditable &&
                <AddRowButton eqName={'products'} variant={variants.textWithIcon}
                  addAction={() => {
                    append({...productRow});
                  }}
                />}
              </form>

            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <Grid container width={'100%'} spacing={3}>
        <NotAllowedToEditSection show={props.tabProps.notAllowedToEdit}/>
        <Box
          sx={{
            position: 'fixed',
            left: '-10000px',
            top: 0,
            width: '8.5in',
            height: '11in',
            overflow: 'hidden',
            zIndex: -1,
            opacity: 0,
            pointerEvents: 'none',
          }}
        >
          <div ref={priceFlyerRef}>
            <PriceListFlyerTemplate
              companyName={getCompanyData()?.[COMPANY_FIELDS.NAME.api_name]}
              services={pdfFlyerServices}
              isContinuationPage={pdfFlyerPageIndex > 0}
              isLastPage={pdfFlyerPageIndex === (pdfFlyerTotalPages - 1)}
            />
          </div>
        </Box>
        <Grid item flex={1}>
          <Tabs selectedIndex={currentTab} onSelect={(index) => setCurrentTab(index)}>
            <TabList>
              <Tab>Financial Info</Tab>
              <Tab>Price List</Tab>
            </TabList>
            <TabPanel>
              {(currentTab === 0) && getFinancialInfo()}
            </TabPanel>
            <TabPanel>
              {(currentTab === 1) && getPriceList()}
            </TabPanel>
          </Tabs>
        </Grid>       
      </Grid>
    </>
  );
};

CompanyFinancial.propTypes = companyPropTypes;
CompanyFinancial.defaultProps = companyDefaultProps;
